export default __webpack_public_path__ + "static/media/park_linowy_uchwala_instrukcja.1f1869c9.doc";